import "moment/locale/it"
import { Col, Row } from "react-bootstrap"
import { statNumberToString } from "../../../apis/transform/stats"
import { Progress } from "antd"

export function PlayerMatches({
  matchesPlayed,
  startingElevenMatches,
}: {
  matchesPlayed: number
  startingElevenMatches: number
}) {
  return (
    <Col className={"colStats"}>
      <Row className={"paddingBottom20"}>
        <Col sm={6} className={"centerColumn"}>
          <Row>
            <Col className={"competitionSeasonValueLarge"}>{statNumberToString(matchesPlayed)}</Col>
          </Row>
          <Row>
            <Col className={"competitionSeasonLabel"}>Partite giocate</Col>
          </Row>
        </Col>
        <Col sm={6} className={"centerColumn"}>
          <Row className={"marginBottom20"}>
            <Col>
              <Progress
                type="circle"
                percent={parseFloat(statNumberToString((startingElevenMatches / matchesPlayed) * 100))}
                strokeLinecap={"square"}
                strokeColor={"#f4c400"}
                format={() => {
                  return statNumberToString(startingElevenMatches)
                }}
                width={140}
                trailColor="white"
              />
            </Col>
          </Row>
          <Row>
            <Col className={"competitionSeasonLabel"}>Da titolare</Col>
          </Row>
        </Col>
      </Row>
    </Col>
  )
}
